// Maps backend AppError codes (backend/src/errors/AppError.ts) to i18n keys
// under the `online.errors` namespace — see src/locales/*/translation.json.
const KNOWN_CODES = new Set([
    'EMAIL_ALREADY_REGISTERED',
    'INVALID_CREDENTIALS',
    'ACCOUNT_BLOCKED',
    'ACCOUNT_DELETED',
    'TOKEN_INVALID',
    'TOKEN_EXPIRED',
    'UNAUTHORIZED',
    'FORBIDDEN',
    'VALIDATION_ERROR',
    'ROOM_NOT_FOUND',
    'ROOM_EXPIRED',
    'ROOM_FULL',
    'ROOM_NOT_JOINABLE',
    'ALREADY_IN_ROOM',
    'NOT_ROOM_HOST',
    'NOT_IN_ROOM',
    'RATE_LIMITED',
    'NETWORK_ERROR',
    'INVALID_PASSWORD',
    'EMAIL_VERIFICATION_INVALID',
    'EMAIL_ALREADY_VERIFIED',
    'OAUTH_NOT_CONFIGURED',
    'OAUTH_ERROR',
]);

export function getErrorMessageKey(code) {
    return `online.errors.${KNOWN_CODES.has(code) ? code : 'generic'}`;
}
